<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose">
        <div class="row">
            <div class="col-md-12">
                <x-select v-model="form.payment_method_type_ids"
                          multiple
                          :multiple-limit="4"
                          label="Métodos de pago"
                          :options="payment_method_types">
                </x-select>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose" text="Cerrar"></x-button-cancel>
                <x-button-submit @click="onSubmit" text="Generar"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>
import XSelect from "../../../../components/Form/XSelect.vue";
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XModal from "../../../../components/XModal.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";

export default {
    name: 'ReportCashDiary',
    components: {XButtonCancel, XModal, XButtonSubmit, XSelect},
    props: ['showDialog', 'recordId'],
    data() {
        return {
            title: 'Reporte diario',
            loading: false,
            resource: 'cash',
            errors: {},
            form: {},
            payment_method_types: []
        }
    },
    async created() {
        await this.initTables()
    },
    methods: {
        async initTables() {
            this.payment_method_types = []
            await this.$http.get(`/${this.resource}/report_diary/tables`)
                .then(response => {
                    this.payment_method_types = response.data.payment_method_types
                })

        },
        initForm() {
            this.errors = {}
            this.form = {
                cash_id: this.recordId,
                payment_method_type_ids: [],
            }
        },
        handleOpen() {
            this.initForm()
        },
        async onSubmit() {
            if (this.form.payment_method_type_ids.length === 0) {
                return this.$message.error('Debe seleccionar al menos un método de pago')
            }
            this.loading = true

            await this.$http({
                url: `/${this.resource}/report_diary_2`,
                method: 'POST',
                responseType: 'blob',
                data: this.form
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = 'Reporte_diario_' + moment().format('YYYYMMDDHHmmss')
                    let extension = '.pdf';
                    link.setAttribute('download', fileName + extension)
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(error => {
                    this.errors = error
                })
                .finally(() => {
                    this.loading = false
                })


            // await this.$http.post(`/${this.resource}/report_diary`, this.form)
            //     .then(response => {
            //         if (response.data.success) {
            //             this.$message.success('El correo fue enviado satisfactoriamente')
            //         } else {
            //             this.$message.error('Error al enviar el correo')
            //         }
            //     })
            //     .catch(error => {
            //         if (error.response.status === 422) {
            //             this.errors = error.response.data.errors
            //         } else {
            //             this.$message.error(error.response.data.message)
            //         }
            //     })
            //     .finally(() => {
            //         this.loading = false
            //     })
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
